import { axiosInstance } from './common';

export const listOrganizations = (search, page = 0, size = 20) => {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  params.append('page', page);
  params.append('size', size);
  return axiosInstance.get(`/admin/organizations?${params.toString()}`).then((r) => r.data);
};

export const createOrganization = (name, description, ownerId) =>
  axiosInstance.post('/admin/organizations', { name, description, ownerId }).then((r) => r.data);

export const getOrganization = (id) =>
  axiosInstance.get(`/admin/organizations/${id}`).then((r) => r.data);

export const updateOrganization = (id, name, description) =>
  axiosInstance.put(`/admin/organizations/${id}`, { name, description }).then((r) => r.data);

export const deleteOrganization = (id) =>
  axiosInstance.delete(`/admin/organizations/${id}`).then((r) => r.data);

export const transferOwnership = (id, newOwnerId) =>
  axiosInstance.post(`/admin/organizations/${id}/transfer`, { newOwnerId }).then((r) => r.data);

export const removeMember = (id, userId) =>
  axiosInstance.delete(`/admin/organizations/${id}/members/${userId}`).then((r) => r.data);

export const changeMemberRole = (id, userId, role) =>
  axiosInstance.put(`/admin/organizations/${id}/members/${userId}/role`, { role }).then((r) => r.data);

export const listInvites = (id) =>
  axiosInstance.get(`/admin/organizations/${id}/invites`).then((r) => r.data);

export const createInvite = (id, email, role) =>
  axiosInstance.post(`/admin/organizations/${id}/invites`, { email, role }).then((r) => r.data);

export const revokeInvite = (id, inviteId) =>
  axiosInstance.delete(`/admin/organizations/${id}/invites/${inviteId}`).then((r) => r.data);
